import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { SaleDetailService } from '../sale-pending/sale-details.service';

@Component({
  selector: 'ami-detail-dialog',
  templateUrl: './detail-dialog.component.html'
})
export class DetailDialogComponent {
  visible = true;
  @Input() idDocument: number;
  @Output() onHideData = new EventEmitter<boolean>();
  detailsResponse: any[];
  tableDetailSettings: ISettingsTable;
  constructor(private saleDetailService: SaleDetailService) {}

  async ngOnInit() {
    // console.log('Initializing detail dialog');
    this.tableDetailSettings = {
      title: 'Detalle de documento',
      columns: [
        { header: 'Descripción', field: 'description' },
        { header: 'Cantidad.', field: 'quantity' },
        { header: 'Unidad', field: 'unit' },
        { header: 'Monto.Val.Unit', field: 'mtoValueUnit' },
        { header: 'Monto.Val.Ven', field: 'mtoValueSale' }
      ]
    };

    const { data: detailResponse, status } =
      await this.saleDetailService.getById(this.idDocument);

    if (status === 200) {
      this.detailsResponse = detailResponse as any[];
      this.visible = true;
    }
  }

  onHideDataDialog() {
    this.visible = false;
    this.onHideData.emit();
  }
}
